import {
  StatusIndicator,
  StatusIndicatorProps,
} from '@amzn/awsui-components-react';
import { ReactElement } from 'react';
import { NameSyncStatus } from '@amzn/awsdev-docs-virtual-smiley-typescript-client';

const statusMap: Record<NameSyncStatus, StatusIndicatorProps> = {
  IN_SYNC: {
    type: 'success',
    children: 'In sync',
  },
  DRIFT: {
    type: 'warning',
    children: 'Drift',
  },
  NOT_APPLICABLE: {
    type: 'not-started',
    children: 'N/A',
  },
  NOT_IN_XML: {
    type: 'info',
    children: 'Not in XML',
  },
} as const;

export const NameSyncStatusIndicator = ({
  status,
}: {
  status: NameSyncStatus;
}): ReactElement => <StatusIndicator {...statusMap[status]} />;
